import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { RoleUrl } from './RoleUrl';
import { RoleDto, RoleValidFormData } from '../schema/types';
import { RoleMutationSchema } from '../schema/RoleSchema';

const postRole = (role: RoleValidFormData) =>
  apiClient
    .post<RoleDto>(expand(RoleUrl.ROLE, {}), RoleMutationSchema.parse(role))
    .then((response) => response.data);

const patchRole = (id: number, role: Partial<RoleValidFormData>) =>
  apiClient
    .put<RoleDto>(expand(RoleUrl.ROLE, { id }), RoleMutationSchema.parse(role))
    .then((response) => response.data);

const deleteRole = (id: number) =>
  apiClient
    .delete<void>(expand(RoleUrl.ROLE, { id }))
    .then((response) => response.data);

export const useMutateRole = createApiMutationHook(
  ['role'],
  getMutationFn(postRole, patchRole, deleteRole)
);
